module.exports = __webpack_public_path__ + "img/case63.29559a02.png";